import {O} from "web-vcore";
import {LightsState} from "./engine/lights";
import {SoundsState} from "./engine/sounds";
import {ConfigState} from "./engine/config.js";
import {JourneyState} from "./tools/journey.js";

export class EngineState {
	@O accessor subpage = "config";
	@O accessor config = new ConfigState();
	@O accessor journey = new JourneyState();
	@O accessor sounds = new SoundsState();
	@O accessor lights = new LightsState();
}